import {
    HttpResponse,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    ApplicationUserModel,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class ApplicationUserDataService implements CrudService<ApplicationUserModel, ApplicationUserModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<ApplicationUserModel>): Promise<CrudListResponse<ApplicationUserModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ApplicationUserModel>> {
        return ApiService.api.getApplicationUser(params);
    }

    create(item: ApplicationUserModel, params?: RequestParams): Promise<CrudResponse<ApplicationUserModel>> {
        throw new Error('NotImplemented');
    }

    update(item: ApplicationUserModel, params?: RequestParams): Promise<ApplicationUserModel> {
        return ApiService.api.updateApplicationUser(item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ApplicationUserModel> {
        throw new Error('NotImplemented');
    }

    delete(query: CrudDataQuery<ApplicationUserModel>): Promise<CrudListResponse<ApplicationUserModel>> {
        throw new Error('NotImplemented');
    }

    download(query: CrudDataQuery<ApplicationUserModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
